// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import HotelClassificationBusinessListResourceViewModel from '../../../../viewModel/resource/HotelClassificationBusinessListResourceViewModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import HotelClassificationBusinessListResourceListResultViewModel from '../../../../viewModel/resource/HotelClassificationBusinessListResourceListResultViewModel';
import HotelClassificationBusinessListResourceListResultDTO from '../../dto/resource/HotelClassificationBusinessListResourceListResultDTO';

export default abstract class HotelClassificationBusinessListResourceListResultModel extends BaseModel<HotelClassificationBusinessListResourceListResultDTO> {
  /**
  */
  get items() { return this.getArrayModels(() => this.dto.items, HotelClassificationBusinessListResourceViewModel)!; }
  set items(value) { this.setArrayModels(() => this.dto.items, value); }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
  }
}
